const host = process.env.REACT_APP_URL
export const generateOtpUrl = `${host}api/v1/user/send_otp/`
export const verifyOtpUrl = `${host}api/v1/auth/verify-otp-and-get-session/`
export const resendOTPUrl = `${host}api/v1/user/resend_otp/`
export const updateUserUrl = `${host}api/v1/user/edit-user/`
export const checkWhatsAppOTPStatusUrl = `${host}api/v1/user/check_whatsapp_status/`
export const logoutUrl = `${host}api/v1/auth/logout/`
export const checkAuthUrl = `${host}api/v1/auth/verify-session/`
export const ssoUrl = `${host}api/v1/auth/verify-sso-token/`
